function convertImageUrlsToS3Key(newBody: string) {
  try {
    const regex = RegExp(/.*?(<img src="(.*?)">).*?/, 'g') //first item match
    let match
    while ((match = regex.exec(newBody)) !== null) {
      const path = new URL(match[2]).pathname?.replace('/', '')
      newBody = newBody.replace(match[1], `[[s3Key:${path}]]`)
      regex.lastIndex = 0 //start search from begining again
    }
    return newBody
  } catch (e) {
    return newBody
  }
}
export default convertImageUrlsToS3Key
